import React, { useMemo, useState } from "react";
import { Row } from "../common/Layout";
import Button from "../common/Button";
import TableWrapper from "../common/TableWrapper";
import AllowedAddressModal from "../modals/AllowedAddressModal";
import ConfirmDeleteAddressModal from "../modals/ConfirmDeleteAddressModal";
import NetworkService from "../../NetworkService";
import { toasterFunction } from "../utils";
import { Message } from "rsuite";

export default function AllowedAddressesSection({
  userId,
  allowedAddresses,
  onUserRefresh,
  title = "Allowed address:",
}) {
  const data = allowedAddresses || [];

  const [modalOpen, setModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const editingAddress = useMemo(() => {
    if (editingIndex === null || editingIndex === undefined) return null;
    return data?.[editingIndex] || null;
  }, [data, editingIndex]);

  const columns = [
    {
      header: "#",
      render: (_row, i) => <b>{i + 1}</b>,
      options: { width: 70 },
    },
    {
      header: "Address name",
      dataKey: "address",
      options: { width: 400, resizable: true },
    },
    {
      header: "Address radius",
      dataKey: "radius",
      options: { width: 220, resizable: true },
      render: (_row, i) => <>{_row.radius} m</>,
    },
    {
      header: "Action",
      render: (_rowData, i) => (
        <div style={{ display: "flex", gap: 10 }}>
          <Button
            variant="white"
            onClick={() => {
              setEditingIndex(i);
              setModalOpen(true);
            }}>
            Edit
          </Button>
          <Button
            variant="white"
            onClick={() => {
              setDeleteIndex(i);
            }}>
            Delete
          </Button>
        </div>
      ),
      options: { width: 220, fixed: "right" },
    },
  ];

  console.log(data);

  return (
    <div style={{ width: "100%" }}>
      {modalOpen && (
        <AllowedAddressModal
          open={modalOpen}
          close={() => {
            setModalOpen(false);
            setEditingIndex(null);
          }}
          initialAddress={editingAddress}
          onSave={(saved, { isEdit }) => {
            const next = [...(data || [])];
            if (isEdit && editingIndex !== null && editingIndex !== undefined) {
              next[editingIndex] = { ...next[editingIndex], ...saved };
            } else {
              next.push(saved);
            }

            const parsedUserId = parseInt(userId, 10);
            const userIds = [userId, ...(saved.apply_to_users || [])];
            const addressToSubmit = {
              address: saved.address,
              lat: saved.lat,
              lng: saved.lng,
              radius: saved.radius,
            };

            if (isEdit) {
              NetworkService.editUser({
                id: userId,
                allowed_address: next,
              })
                .then(() => {
                  onUserRefresh?.();
                  setModalOpen(false);
                  setEditingIndex(null);
                  toasterFunction(
                    <Message closable type="success">
                      User addresses successfully updated.
                    </Message>,
                  );
                })
                .catch((e) => {
                  console.log(e);
                  toasterFunction(
                    <Message closable type="error">
                      Error while updating addresses.
                    </Message>,
                  );
                });
            } else {
              NetworkService.bulkUpdateUsers(userIds, [addressToSubmit])
                .then(() => {
                  onUserRefresh?.();
                  setModalOpen(false);
                  setEditingIndex(null);
                  toasterFunction(
                    <Message closable type="success">
                      User addresses successfully updated.
                    </Message>,
                  );
                })
                .catch((e) => {
                  console.log(e);
                  toasterFunction(
                    <Message closable type="error">
                      Error while updating addresses.
                    </Message>,
                  );
                });
            }
          }}
        />
      )}

      <ConfirmDeleteAddressModal
        isOpen={deleteIndex !== null && deleteIndex !== undefined}
        close={() => setDeleteIndex(null)}
        onYes={() => {
          const idx = deleteIndex;
          setDeleteIndex(null);
          const next = (data || []).filter((_x, i) => i !== idx);

          NetworkService.editUser({
            id: userId,
            allowed_address: next,
          })
            .then(() => {
              onUserRefresh?.();
              toasterFunction(
                <Message closable type="success">
                  Address successfully removed.
                </Message>,
              );
            })
            .catch((e) => {
              console.log(e);
              toasterFunction(
                <Message closable type="error">
                  Error while removing address.
                </Message>,
              );
            });
        }}
      />

      <Row style={{ alignItems: "center", justifyContent: "space-between", marginBottom: 12, marginTop: 20 }}>
        <div style={{ color: "#B0B4BA", fontSize: 18, fontWeight: 800, lineHeight: "28px" }}>
          {title}
        </div>
        <Button
          style={{ height: 48 }}
          variant="white"
          onClick={() => {
            setEditingIndex(null);
            setModalOpen(true);
          }}> 
          Add Allowed Address
        </Button>
      </Row>

      <TableWrapper hidePagination data={data} columns={columns} emptyMessage="Nothing here. This user nas no GEO restrictions" />
    </div>
  );
}
